import { getDatabase, ref, child, set, get, update, push, remove } from "firebase/database";
const db = getDatabase();

export const GetRealTree = function (path) {
  if (!path) return;

  return get(child(ref(db), path)).then((snapshot) => {
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      return {};
    }
  })

};

export const GET = function (path) {
  if (!path) return;
  return GetRealTree(path)
    .then((data) => {
      const items = [];
      for (const key in data) {
        const item = { id: key, ...data[key] };
        item.id = key; //replace if item has (non-unique) id in DB
        items.push(item);
      }
      return items;
    });
};


export const PUT = function (data, path = "default") {
  return set(ref(db, path), data);
};

export const PATCH = function (data, path = "default") {
  return update(child(ref(db), path), data);
};


export const POST = function (data, path = "default") {
  const postListRef = ref(db, path);
  const newPostRef = push(postListRef);
  return set(newPostRef, data);
};

export const DELETE = function(path){
  if (!path) return;
  return remove(ref(db, path))
}